import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { HistoryFieldProps } from './history-field.component';
import HistoryField from './history-field.component';

export interface HfHistoryFieldProps extends HistoryFieldProps {
  control: Control<FieldValues>;
  name: string;
}

export default function HfHistoryField({
  control,
  name,
  label,
  imageSrc,
  value,
  readOnly,
  required,
  onChange,
  fieldValueConverter,
  labelStyles,
  fullName,
}: HfHistoryFieldProps) {
  return (
    <OdinController
      name={name}
      control={control}
      defaultValue={value}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { ref, onChange, value }, fieldState: { error } }) => (
        <HistoryField
          inputRef={ref}
          name={name}
          label={label}
          imageSrc={imageSrc}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          required={required}
          error={error?.message}
          labelStyles={labelStyles}
          fullName={fullName}
        />
      )}
    />
  );
}
